export interface IMembership {
  id: number;
  club: number;
  is_admin: boolean;
  is_staff: boolean;
  position: string | null;
  status: 'active' | 'inactive';
}

export interface IMembershipsStore extends Array<IMembership> {}

export const membershipsStore: IMembershipsStore = [];
